import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { isLoggedIn } from "../../features/login/loginSlice";
import { selectUser } from "../../features/home/userSlice";
import { selectAccounts } from "../../features/manageAccounts/accountsSlice";
import { clearNewTransaction, selectNewTransaction } from "../../features/transactionList/transactionsSlice";
import { setConfirmingWithdrawal } from "../../features/withdrawalForm/withdrawalFormSlice";
import Sidebar from "../sidebar/Sidebar";

export default function WithdrawalConfirmation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const loggedIn = useSelector(isLoggedIn);
    const userInfo = useSelector(selectUser)
    const bankId = userInfo.bankId;

    const accounts = useSelector(selectAccounts);
    const newTransaction = useSelector(selectNewTransaction);

    let month;
    let day;
    let year;
    if (newTransaction.id) {
        let transactionDate = newTransaction.transactionDate.split("T")[0].split("-");
        month = transactionDate[1];
        day = transactionDate[2];
        year = transactionDate[0];
    }

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    const handleClick = () => {
        dispatch(clearNewTransaction());
        dispatch(setConfirmingWithdrawal(false));
        navigate(`../${bankId}/withdrawal`);
    }

    return (
        <main>
            <Sidebar />
            {!newTransaction.id ? "" :
                <section className="withdrawal-confirmation">
                    <h2>Withdrawal Confirmation</h2>
                    <h3><span>Withdrawal Account:</span> {Object.values(accounts).find(account => account.accountId === newTransaction.accountId).accountType} {newTransaction.accountId}</h3>
                    <h3><span>Amount: $</span>{newTransaction.amount.toFixed(2)}</h3>
                    <h3><span>Transaction Date:</span> {`${month}/${day}/${year}`}</h3>
                    <h3><span>Transaction Id:</span> {newTransaction.id}</h3>
                    <button onClick={handleClick}>Make Another Withdrawal</button>
                </section>
            }
        </main>
    )
}